import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config';
import moment from 'moment';
import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';
import { custom_sort } from '../../../services/utility';
import { getNoOfDaysFromCurrentDate } from '../../../services/DateCalcFuntion';

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      todate: '',
      fromdate: '',
      manifestFromDate: '',
      manifestToDate: '',
      investigationStatus: '',
      investigationStatusOptions: [
        { id: 'open', label: 'Open' },
        { id: 'close', label: 'Close' }
      ],
      show: false,
      show2: false,
      // for hun list
      hub: '',
      hublist: [],
      // for status list
      Status: '',
      StatusList: [],
      // verification Status
      vStatus: '',
      vStatusList: [],
      myStr: '',
      accesszonelist: '',
      parsedata: '',
      isLoading1: false,
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      listUserData: [],
      awbnumber: '',
      awbNumbers: [],
      msg: '',
      error: false,

      // table
      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',

      // client list
      clienList: [],
      hubdroplist: [],
      editshowtable: false,
      operator: '',
      operatorOptions: [
        { id: '1', label: '>' },
        { id: '2', label: '<' },
        { id: '3', label: '=' }
      ],
      octroi_MRP: '',
      exportdis: '',
      ListData: [],
      List: [],
      imagePathData: '',
      abc: '',
      primaryKey: '',
      imgData: '',
      showModal: false,
      errormsg: '',
      show1: false,
      totalcount: 0,
      pageValue: 0,
      verification: [],
      recreasons: [],
      Awb: [],
      vertical:'',
      verticalList: [{
        id:'1',
        label: 'B2C-Ecom'
      }, {
        id:'2',
        label: 'B2C-Heavies'
      }],
      //editable:true,
      RECReasonMap: {},
      link: `https://${awsBucketName.awsBucketName}.s3.ap-southeast-1.amazonaws.com/`
    };
  },
  mounted() {
    variables.pageRecordLimit = 50;
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);

    this.getzonehubs();
    this.statusfunction();
    this.verificationStatus();
    this.verificationStatusName();
    this.recReasonFetchData();
    if (localStorage.getItem('financepageData') !== null) {
      let pageNum = localStorage.getItem('pageNum');
      let input = JSON.parse(localStorage.getItem('financepageData'));
      localStorage.removeItem('financepageData');
      if (input === undefined) { input = ''; }
      this.hydrateDateFilters(input);
      this.getPaginationData(pageNum ? pageNum : 1, input)
      localStorage.removeItem('pageNum')
    }
  },
  destroyed() {
    localStorage.removeItem('financepageData');
  },
  computed: {
    checkDisabled: function () {
      const selectedOperator = this.operator && this.operator.id ? this.operator.id : this.operator;
      return selectedOperator === '' || selectedOperator === null || selectedOperator === undefined;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
  },
  methods: {
    normalizeDateForInput(dateValue) {
      if (!dateValue) {
        return '';
      }
      const normalizedDate = moment(dateValue, [
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        'DD/MM/YYYY',
        'D/M/YYYY',
        'D/MM/YYYY',
        'DD/M/YYYY',
        'MM/DD/YYYY',
        'M/D/YYYY',
        'M/DD/YYYY',
        'MM/D/YYYY'
      ], true);

      if (normalizedDate.isValid()) {
        return normalizedDate.format('YYYY-MM-DD');
      }

      const fallbackDate = moment(new Date(dateValue));
      return fallbackDate.isValid() ? fallbackDate.format('YYYY-MM-DD') : '';
    },
    hydrateDateFilters(input = {}) {
      this.fromdate = this.normalizeDateForInput(input.FromDate || input.fromdate || this.fromdate);
      this.todate = this.normalizeDateForInput(input.ToDate || input.todate || this.todate);
      this.manifestFromDate = this.normalizeDateForInput(input.frommanifesteddate || input.manifestFromDate || this.manifestFromDate);
      this.manifestToDate = this.normalizeDateForInput(input.tomanifesteddate || input.manifestToDate || this.manifestToDate);
    },
    getzonehubs() {
      this.show = true;
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getZoneList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.show = false;
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename,
          });
        });

        this.newhublist = finalHubData;

      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    callHub(newhublist) {
      this.hublist = [];

      this.getHubList(newhublist.id);
      this.hub = '';
      if (newhublist.id != undefined) {
        this.getHubList();
      }
    },
    statusfunction() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}status`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const statusdata = [];
        result.data.data.forEach((status) => {
          if (status.statuscode === 15) {
            statusdata.push({
              id: status.statuscode,
              label: status.statusname,
            });
          }
        });

        this.StatusList = statusdata;
        this.Status = this.StatusList.find(status => status.id === 15)
      },
        (error) => {
          console.error(error);
        });
    },
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata
      },
        error => {

          console.error(error)
        })

    },

    verificationStatus() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.vStatusList = vstatusdata
      },
        error => {

          console.error(error)
        })

    },

    getHubList(id) {
      const finalhublist = [];
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i].HubZoneId) {
          finalhublist.push({
            id: this.parsedata.hubaccess[i].HubID,
            label: this.parsedata.hubaccess[i].HubName,
          });
          this.hublist = finalhublist;
        }
      }
    },
    ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      let path = '';
      this.primaryKey = 123;
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      this.input = ({
        key: path,
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getListObjectFroms3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const images = result.data.data.Contents.sort(custom_sort);
        this.List = images.slice(0, 3);
        if (this.List.length <= 0) {
          this.errormsg = "No Image Found"
        }
      });
    },

    downloadImage(filePath) {
      this.show1 = true;

      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
      });


      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },

    resetForm() {
      this.pageValue = 0
      this.awbnumber = ''
      this.vertical ='',
      this.octroi_MRP = '',
        this.Status = '';
      this.vStatus = '';
      this.fromdate = '';
      this.todate = ''
      this.manifestFromDate = '';
      this.manifestToDate = '';
      this.investigationStatus = '';
      this.hub = '';
      this.newhubs = '';
      this.exportdis = '';
      this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;
      this.listUserData = []; this.pageno = 0; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';

    },

    // get client list
    getClientList() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getClientList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.clienList = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {
          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j].clientid !== null
              && this.listUserData[j].clientid != undefined) {
              if (this.clienList[i].ClientMasterID == this.listUserData[j].clientid) {
                this.listUserData[j].Clientname = this.clienList[i].CompanyName;
              }
            }
          }
        }

        this.editshowtable = true;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    getregionname() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j].hubzoneid !== null
            && this.listUserData[j].hubzoneid != undefined) {
            if (this.newhublist[i].id == this.listUserData[j].hubzoneid) {
              this.listUserData[j].regionname = this.newhublist[i].label;
            }
          }
        }
      }

      this.editshowtable = true;
    },

    // dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getHubdropdownlist`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName,
          });
        });
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].currenthubid !== null
              && this.listUserData[j].currenthubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].currenthubid) {
                this.listUserData[j].currenthubname = this.hubdroplist[i].label;
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].originhubid !== null
              && this.listUserData[j].originhubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].originhubid) {
                this.listUserData[j].originhubname = this.hubdroplist[i].label;
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].finaldestinationid !== null
              && this.listUserData[j].finaldestinationid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].finaldestinationid) {
                this.listUserData[j].finaldestinationname = this.hubdroplist[i].label;
              }
            }
          }
        }

        this.editshowtable = true;
      },
        (error) => {
          console.error(error);
        });
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["VerificationStatus"] = this.verification[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },
    // to get pagination
    getPaginationData(pageNum, input = '') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum - 1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno, input)
    },
    NewAwb() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'stdrecreasonmapping',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {

        let statusdata = []
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.shippingid,
            lable: status.recreasonid
          })
        })
        this.Awb = statusdata
        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.Awb.length; i++) {
            if (this.listUserData[j]["shippingid"] !== null && this.listUserData[j]["shippingid"] != undefined) {

              if (this.Awb[i]["id"] == this.listUserData[j]["shippingid"]) {
                this.listUserData[j]["recreasionid"] = this.Awb[i]["lable"];


              }
            }
          }

        }

        this.editshowtable = true;
      },
        (error) => {
          console.error(error);
        });
    },
    async getDisputeStatusName(data) {
      let i = 0;
      for (let d of data) {
        if (d.disputestatuscode !== null && d.disputestatuscode !== undefined && d.disputestatuscode !== '' &&
          d.status !== null && d.status !== undefined && d.status !== '') {
          this.input = ({
            Status: d.status,
            DisputeStatusCode: d.disputestatuscode
          });
          let result = await this.getDisputeStatusNameAPICall(this.input);
          this.listUserData[i].disputstatusname = result
        } else {
          this.listUserData[i].disputstatusname = '-'
        }
        i++;
      }
    },

    getDisputeStatusNameAPICall(input) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: apiUrl.api_url + 'DisputeSubStatus',
          data: input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          return resolve(result.data.data[0] ? result.data.data[0].pickupstatusname : '-');
        }).catch(err => {
          return reject(err);
        })
      })
    },
    NewAwb(data) {
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if (data.shippingid === status.shippingid) {
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },

    Recreasion(data) {
      let RecReason;
      if (data !== null && data !== undefined) {
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData() {
      RecReasonData(this.myStr).then(result => {
        this.recreasons = result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    // searchbutton
    searchData(pageNo, input = '') {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString()    
      this.hydrateDateFilters();
      this.isLoading1 = true;
      this.show2 = true;
      this.listUserData = []; this.pagecount = 1; this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0
      let AWBNumber = this.awbnumber
      AWBNumber = AWBNumber.split(',')
      console.log('here: ', AWBNumber.length);
      if (this.vStatus.id) {
        var vid = this.vStatus.id;
        var vstatusid = vid.toString();
      }
      var formats= /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if(formats.test(this.awbnumber))
      {
        this.$alertify.error("Please Search Comma Seprated Shippingids")

      }
      else{  
        if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
          this.$alertify.error("Please enter both  date")

        }
        if (AWBNumber.length > '49') {
          this.$alertify.error("Shippingid Should Be Less 50")

        }
        else if (this.fromdate > this.todate) {
          this.$alertify.error("From date should not be greater than To date")

        }
        else if ((this.manifestFromDate && !this.manifestToDate) || (!this.manifestFromDate && this.manifestToDate)) {
          this.$alertify.error("Please enter both shipment manifest dates")
        }
        else if (this.manifestFromDate > this.manifestToDate) {
          this.$alertify.error("Shipment manifest from date should not be greater than to date")
        }
        else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {


          this.input = ({
            offset: pageNo,
            limit: variables.pageRecordLimit,
            shippingid: this.awbnumber,
            FromDate: this.fromdate,
            ToDate: this.todate,
            status: this.Status.id,
            actionstatuscode: vstatusid,
            hubzoneid: this.newhubs.id,
            currenthubid: this.hub.id,
            originhubid: this.hub.id,
            operator: this.operator && this.operator.id ? this.operator.id : this.operator,
            netvalue: this.octroi_MRP,
            vertical:this.vertical.id
          });
          if (this.manifestFromDate && this.manifestToDate) {
            this.input.frommanifesteddate = `${this.manifestFromDate.slice(0, 10)} 00:00:00`;
            this.input.tomanifesteddate = `${this.manifestToDate.slice(0, 10)} 23:59:59`;
          }
          const selectedInvestigationStatus =
            this.investigationStatus && this.investigationStatus.id
              ? this.investigationStatus.id
              : this.investigationStatus;
          if (selectedInvestigationStatus) {
            this.input.investigationstatus = selectedInvestigationStatus === 'open';
          }

          this.defaultSearch = Object.assign({}, input ? input : this.input);
          if (input === '') {
            localStorage.setItem('financepageData', JSON.stringify(this.input))
          }
          axios({
            method: 'post',
            url: `${apiUrl.api_url}searhapiActionbyFinanceonForcefullyLost`,
            data: input ? input : this.input,
            headers: {
              Authorization: `Bearer ${this.myStr}`,
            },
          }).then((result) => {
            this.show2 = false
            this.listUserData = [];

            this.totalcount = typeof result.data.count === 'number'
              ? result.data.count
              : (Array.isArray(result.data.data) ? result.data.data.length : 0)
            if (this.totalcount == undefined) {
              this.totalcount = 0
            }
            (Array.isArray(result.data.data) ? result.data.data : []).forEach(ele => {
              if (ele.status == 15 && (ele.actionstatuscode == '' || ele.actionstatuscode == 24 || ele.actionstatuscode == 25)) {
                ele.editable = false;
              } else {
                ele.editable = true;
              }
              this.listUserData.push(ele)

            });
            if (!this.listUserData.length) {
              this.isLoading1 = false;
              this.$alertify.error('No records found for the selected search filters');
            }
            this.NewAwb(this.listUserData);
            this.getClientList();
            this.gethubdropdown();
            this.getregionname();
            this.Statusname();
            this.buckettypecode()
            this.verificationStatusList()
            this.Recreasion()
            this.getDisputeStatusName(this.listUserData)
            if (this.totalcount < variables.pageRecordLimit) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(this.totalcount / variables.pageRecordLimit);
            }
          });
        }//else
      }//else
    },

    toggle() {
      let checkboxes = document.getElementsByName('chk-shipment');
      let actionCheckbox = document.getElementsByName('actionToggle');
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        if (actionCheckbox[0].checked) {
          if (!checkboxes[i].checked) {
            checkboxes[i].click()
          }
        } else {
          if (checkboxes[i].checked) {
            checkboxes[i].click()
          }
        }
        // checkboxes[i].checked = actionCheckbox[0].checked;
        // console.log(JSON.stringify(checkboxes[i].value));
      }
    },
    exportfileCSV() {
      const exportPayload = Object.assign({}, this.defaultSearch || this.input || {});
      delete exportPayload.offset;
      delete exportPayload.limit;
      exportPayload.exportdata = true;

      if (!Object.keys(exportPayload).length) {
        this.$alertify.error('Please search data first');
        return;
      }

      this.show2 = true;
      axios({
        method: 'post',
        url: `${apiUrl.api_url}searhapiActionbyFinanceonForcefullyLost`,
        data: exportPayload,
        responseType: 'arraybuffer',
        headers: {
          Authorization: `Bearer ${this.myStr}`,
          'Content-type': 'application/json'
        },
      }).then((response) => {
        this.show2 = false;

        if (!response.data || response.data.byteLength === 0) {
          this.$alertify.error('No data Found');
          return;
        }

        this.downloadCSV(response.data, `Action_by_Finance_on_Forcefully_Lost${moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`);
      }, (error) => {
        this.show2 = false;
        console.error(error);
        this.$alertify.error('Failed to export data');
      });
    },

    downloadCSV(fileData, filename) {
      const blob = new Blob([fileData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename || 'Action_by_Finance_on_Forcefully_Lost.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString() + ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ',' + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ',' + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' + data[i].phyweight + ',' + data[i].volweight + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ',' + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription + ',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].shortagetype + ',' + data[i].bagno + ',' + data[i].recreasionname;

        result += lineDelimiter;


      }
      return result;
    },
    neweditpage() {

      if (this.awbNumbers.length > 0) {
        this.$router.push({
          path: '/EditActionByFinance',
          query: { awb: this.awbNumbers },
        });
      } else {
        // localStorage.removeItem('financepageData')

        this.msg = 'Please Select at least one item';
        this.error = true;
      }
    },

  },
};



// WEBPACK FOOTER //
// ./src/views/components/ActionByFinanceForcefullyLostBulk/ActionByFinanceForcefullyLostBulk.component.js